import { useShallow } from "zustand/react/shallow";
import { useFormStore } from "@/store/form-builder";
import { useAssistantStore } from "@/store/form-builder/useAssistantStore";
import { ProposalBanner } from "@/components/features/FormBuilder/Assistant/ProposalBanner";
import styles from "./EditorProposalBanner.module.scss";

export function EditorProposalBanner() {
  const { proposal, stale, isBusy, discardProposal, applyProposal } = useAssistantStore(
    useShallow((s) => ({
      proposal: s.proposal,
      stale: s.stale,
      isBusy: s.phase === "thinking" || s.phase === "building",
      discardProposal: s.discardProposal,
      applyProposal: s.applyProposal,
    })),
  );
  const initFromJSON = useFormStore((s) => s.initFromJSON);
  const questionCount = useFormStore((s) =>
    s.pages.reduce(
      (total, page) =>
        total + page.sections.reduce((sum, section) => sum + section.questions.length, 0),
      0,
    ),
  );

  if (!proposal) return null;

  const handleApply = () => {
    const pages = applyProposal(useFormStore.getState().getCompactJSON());
    if (pages) initFromJSON(pages);
  };

  return (
    <div className={styles.banner}>
      <ProposalBanner
        isStale={stale}
        isBusy={isBusy}
        replacedQuestionCount={questionCount}
        onDiscard={discardProposal}
        onApply={handleApply}
      />
    </div>
  );
}
